export default "__VITE_ASSET__VzoMiH_9__"